import { mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
    computed: {
        ...mapGetters('axiosConfig', ['getConfig'])
    },
    methods: {
        ...mapActions('axiosConfig', ['setConfig']),
        performRequest (request, config = {}) {
            const oldConfig = cloneDeep(this.getConfig)
            this.setConfig(config)

            return request.finally(() => {
                this.setConfig(oldConfig)
            })
        }
    }
}